<template>
  <div>
    <v-breadcrumbs :items="items"></v-breadcrumbs>
    <v-col cols="12">
      <v-alert v-if="errors" prominent type="error" color="red" dense>{{
          errors
        }}</v-alert>
      <v-alert v-if="success" prominent type="success" color="green" dense>{{
          success
        }}</v-alert>
    </v-col>
    <v-row>
      <v-col cols="12">
        <v-alert v-if="error_alert" text prominent type="error" icon="mdi-cloud-alert">{{ error_alert }}
        </v-alert>
        <v-alert
            v-if="success_alert"
            text
            prominent
            type="success"
            icon="mdi-cloud-alert"
        >{{ success_alert }}
        </v-alert
        >
      </v-col>
      <v-col cols="12">
        <v-card-title>
          Video Link & QRCode Data
          <v-spacer></v-spacer>
          <v-spacer></v-spacer>
          <v-spacer></v-spacer>
          <v-spacer></v-spacer>

          <template>
            <v-text-field
                v-model="search"
                prepend-icon="mdi-magnify"
                label="Search"
                single-line
                hide-details
                outlined
                dense
            ></v-text-field>
          </template>
          <v-row align="center" justify="space-around">
            <v-btn color="primary"  @click="add_qrcode_setup()">
              <v-icon>mdi-plus</v-icon>
            </v-btn>
          </v-row>

        </v-card-title>
        <div id="print">
          <v-card>
            <v-data-table
                :headers="headers"
                :items="QRCodeDatas"
                class="elevation-1"
                :search="search"
                dense
                mobile-breakpoint="0"
                :loading="loadingstatus"
                loading-text="Loading... Please wait"
            >
              <template v-slot:item.view_image="{ item }">
                <v-tooltip top>
                  <template v-slot:activator="{ on, attrs }">
                    <v-chip
                        @click="image_view(item)"
                        dark
                        v-bind="attrs"
                        v-on="on"
                        class="ma-2"
                        color="green"
                        label
                        outlined
                        small
                    ><v-icon> mdi-eye </v-icon>
                    </v-chip>
                  </template>
                  <span>View Image</span>
                </v-tooltip>
              </template>
              <template v-slot:item.status="{ item }">
                <v-chip v-if="item.status == 1" dark color="green" label outlined small
                >Active
                </v-chip>
                <v-chip v-if="item.status == 0" dark color="orange" label outlined small
                >Inactive
                </v-chip>
              </template>
              <template v-slot:item.actions="{ item }">
                <v-tooltip top>
                  <template v-slot:activator="{ on, attrs }">
                    <v-chip
                        @click="get_edit_data(item)"
                        dark
                        v-bind="attrs"
                        v-on="on"
                        class="ma-2"
                        color="orange"
                        label
                        outlined
                        small
                    >
                      <v-icon> mdi-pencil</v-icon>
                    </v-chip>
                  </template>
                  <span>Edit</span>
                </v-tooltip>
                <v-tooltip top>
                  <template v-slot:activator="{ on, attrs }">
                    <v-chip
                        @click="delete_data(item)"
                        dark
                        v-bind="attrs"
                        v-on="on"
                        class="ma-2"
                        color="error"
                        label
                        outlined
                        small
                    >
                      <v-icon> mdi-delete</v-icon>
                    </v-chip>
                  </template>
                  <span>Delete</span>
                </v-tooltip>
              </template>
            </v-data-table>
          </v-card>
        </div>

      </v-col>
    </v-row>


    <template>
      <div class="text-center">
        <v-dialog v-model="method_item_dialog" width="500">
          <v-card>
            <v-card-title class="text-h5 grey lighten-2">
              QR Code Setup
              <span v-if="formdata.name">: {{ formdata.name }}</span></v-card-title>
            <template>
              <v-form>
                <v-container>
                  <v-row>
                    <v-col cols="12">
                      <v-text-field
                          v-model="formdata.name"
                          outlined
                          dense
                          label="Video Title"
                          required
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12">
                      <v-text-field
                          v-model="formdata.link"
                          outlined
                          dense
                          label="Video Link"
                          required
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12">
                      <v-autocomplete
                          :items="doctors"
                          color="white"
                          item-text="dr_name"
                          item-key="id"
                          item-value="id"
                          label="Doctor List"
                          v-model="formdata.doctor_list_id"
                          dense
                          outlined
                          :loading="loadingstatus"
                      ></v-autocomplete>
                    </v-col>

                    <v-col cols="12">
                      <v-file-input
                          v-model="formdata.qrcode_image"
                          label="Reference Photo"
                          outlined
                          dense
                          counter
                          chips
                          capture="user"
                          accept="image/*"
                          class="pa-5"
                          v-on:change="onFileChange"
                      ></v-file-input>

                      <v-img
                          v-if="qrcode_preview_image"
                          max-height="100%"
                          max-width="100%"
                          :src="qrcode_preview_image"
                      ></v-img>
                    </v-col>
                    <v-col cols="12">
                      <v-select
                          v-model="formdata.type"
                          :items="type"
                          item-value="key"
                          item-text="value"
                          label="Type"
                          outlined
                          dense
                      ></v-select>
                    </v-col>
                    <v-col cols="12">
                      <v-select
                          v-model="formdata.status"
                          :items="status"
                          item-value="key"
                          item-text="value"
                          label="Item Status"
                          outlined
                          dense
                      ></v-select>
                    </v-col>
                  </v-row>
                </v-container>
              </v-form>
            </template>
            <v-divider></v-divider>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn text @click="method_item_dialog = false"> Cancel</v-btn>
              <v-btn text color="warning" @click="formdata = {}"> Reset</v-btn>
              <v-btn color="primary" text @click="QRCodeDataSubmit"> Submit</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </div>
    </template>
    <template>
      <div class="text-center">
        <v-dialog v-model="method_item_edit_dialog" width="500">
          <v-card>
            <v-card-title class="text-h5 grey lighten-2">
              QR Code Setup Update
              <span v-if="formdataUpdate.name">: {{ formdataUpdate.name }}</span></v-card-title>
            <template>
              <v-form>
                <v-container>
                  <v-row>
                    <v-col cols="12">
                      <v-text-field
                          v-model="formdataUpdate.name"
                          outlined
                          dense
                          label="Video Title"
                          required
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12">
                      <v-text-field
                          v-model="formdataUpdate.link"
                          outlined
                          dense
                          label="Video Link"
                          required
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12">
                      <v-autocomplete
                          :items="doctors"
                          color="white"
                          item-text="dr_name"
                          item-key="id"
                          item-value="id"
                          label="Doctor List"
                          v-model="formdataUpdate.doctor_list_id"
                          dense
                          outlined
                          :loading="loadingstatus"
                      ></v-autocomplete>
                    </v-col>
                    <v-col cols="12">
                      <v-select
                          v-model="formdataUpdate.type"
                          :items="type"
                          item-value="key"
                          item-text="value"
                          label="Type"
                          outlined
                          dense
                      ></v-select>
                    </v-col>
                    <v-col cols="12">
                      <v-select
                          v-model="formdataUpdate.status"
                          :items="status"
                          item-value="key"
                          item-text="value"
                          label="Item Status"
                          outlined
                          dense
                      ></v-select>
                    </v-col>
                  </v-row>
                </v-container>
              </v-form>
            </template>
            <v-divider></v-divider>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn text @click="method_item_edit_dialog = false"> Cancel</v-btn>
              <v-btn text color="warning" @click="formdataUpdate = {}"> Reset</v-btn>
              <v-btn color="primary" text @click="QrCodeDataUpdate"> Submit</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </div>
    </template>
    <template>
      <div class="text-center">
        <v-dialog v-model="dialog" width="850">
          <v-card v-if="imageData">
            <v-card-title class="text-h5 grey lighten-2">
              Title: {{ imageData.name }}</v-card-title
            >
            <v-card-text> </v-card-text>
            <v-img
                contain
                max-height="50%"
                max-width="50%"
                :src="imageData.img_url"
            ></v-img>
            <v-divider></v-divider>

            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="primary" text @click="dialog = false"> close </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </div>
    </template>
  </div>
</template>

<style scoped>
.layout {
  display: inline-block;
  width: 100%;
}
</style>
<script>
import atshq from "../../../js/setup";

export default {
  data() {
    return {
      search: "",
      auto_search: "",
      dialog: false,
      method_item_dialog: false,
      method_item_edit_dialog: false,
      error_alert: null,
      success_alert: null,
      errors: null,
      success: null,
      loadingstatus: true,
      login_user_id: localStorage.getItem("userId"),
      qrcode_preview_image: null,
      imageData: null,
      QRCodeDatas: [],
      type: [
        {key: "Youtube", value: "youtube"},
        {key: "Facebook", value: "facebook"},
      ],
      status: [
        {key: 1, value: "Active"},
        {key: 0, value: "Inactive"},
      ],
      headers: [
        {
          text: "ID",
          align: "start",
          sortable: false,
          value: "id",
        },
        {text: "Name", value: "name"},
        {text: "Type", value: "type"},
        {text: "QR Code", value: "view_image"},
        {text: "Status", value: "status"},
        {text: "Action", value: "actions", sortable: false},
      ],
      desserts: [],
      doctors: [],
      autoheaders: [
        {
          text: "ID",
          align: "start",
          sortable: false,
          value: "id",
        },

        {text: "Action", value: "actions", sortable: false},
      ],
      formdata: {
        name: '',
        doctor_list_id: '',
        link: '',
        qrcode_image: '',
        type: '',
        status: '',
      },
      formdataUpdate: {
        id: null,
        name: '',
        doctor_list_id: null,
        link: '',
        qrcode_image: '',
        type: null,
        status: null,
      },

      items: [
        {
          text: "Dashboard",
          disabled: false,
          href: "/",
        },
        {
          text: "File Manager",
          disabled: true,
          href: "/",
        },
        {
          text: "QR Code",
          disabled: true,
          href: "/",
        },
      ],
      api_base_URL: atshq.defaults.headers.common.api_base_URL,
    };
  },
  // Fetches posts when the component is created.
  created() {
    this.initialize();
    this.get_qrcode_data();
  },
  methods: {
    initialize() {
      atshq
          .get("doctors")
          .then((response) => {
            this.doctors = response.data.data;
            this.loadingstatus = false;
          })
          .catch((e) => {
            this.errors.push(e);
          });
    },
    image_view(items) {
      this.dialog = true;
      this.imageData = items;
    },
    onFileChange(e) {
      this.imagerference = e;
      this.qrcode_preview_image = URL.createObjectURL(this.imagerference);
    },
    get_qrcode_data() {
      atshq
          .get("manager/qrcode-data?login_user_id=" + this.login_user_id)
          .then((response) => {
            this.QRCodeDatas = response.data.QRCodeDatas;
            this.loadingstatus = false;
            this.success = response.data.messages;
            this.errors = null;
          })
          .catch((e) => {
            if (e.response.data.message) {
              this.errors = e.response.data.message;
            } else {
              this.errors = e;
            }
          });
    },
    add_qrcode_setup()
    {
      this.formdata.name = '';
      this.formdata.doctor_list_id = '';
      this.formdata.link = '';
      this.formdata.qrcode_image = '';
      this.formdata.type = '';
      this.formdata.status = '';
      this.method_item_dialog = true;
    },
    get_edit_data(item) {
      this.method_item_edit_dialog = true;
      this.formdataUpdate.id = item.id;
      this.formdataUpdate.name = item.name;
      this.formdataUpdate.doctor_list_id = item.doctor_list_id;
      this.formdataUpdate.link = item.link;
      // this.formdataUpdate.qrcode_image = item.qrcode_image;
      this.formdataUpdate.type = item.type;
      this.formdataUpdate.status = parseInt(item.status);
    },
    QRCodeDataSubmit(e) {
      if (confirm("are you sure?"))
          e.preventDefault(e);
          const config = {
            headers: {
              "content-type": "multipart/form-data",
            },
          };
          let data = new FormData();
          data.append("file", this.formdata.qrcode_image);
          data.append("name", this.formdata.name);
          data.append("doctor_list_id", this.formdata.doctor_list_id);
          data.append("link", this.formdata.link);
          data.append("type", this.formdata.type);
          data.append("status", this.formdata.status);
          data.append("user_id", localStorage.getItem("userId"));
          atshq
              .post("manager/qrcode-data", data,config,)
              .then((response) => {
                this.$noty.success(response.data.message);
                this.get_qrcode_data();
                this.method_item_dialog = false;
              })
              .catch((e) => {
                this.$noty.error(e.response.data.message);
              })

    },
    QrCodeDataUpdate(){
      if (confirm("are you sure?"))

        if (this.formdataUpdate.id) {
          atshq
              .put("manager/qrcode-data/" + this.formdataUpdate.id, {
                data: this.formdataUpdate,
                user_id: localStorage.getItem("userId"),
              })
              .then((res) => {
                this.$noty.success(res.data.message);
                this.get_qrcode_data();
                this.method_item_edit_dialog = false;
              })
              .catch((e) => {
                this.$noty.error(e.response.data.message);
              })
        }
    },
    delete_data(item) {
      if (confirm("are you sure?"))
      atshq
          .delete("manager/qrcode-data/" + item.id)
          .then((response) => {
            this.$noty.success(response.data.message);
            this.success = true;
            this.get_qrcode_data();
          })
          .catch((e) => {
            this.$noty.error(e.response.data.message);
          });
    },
  },
};
</script>
